import React, { Component } from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Plot from "../../utils/customPlotly";
import moment from "moment";

class AvgCompletion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      avg: null,
      actionCount: this.props.actionCount,
      isAllEOPage: this.props.eo_id == null ? true : false,
      loading: false,
    };

    //  console.log(this.props)
  }

  componentDidUpdate(prevProps) {
    let { actionCount } = this.state;

    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats();
    }
  }

  componentDidMount() {
    this.getActionStats();
  }

  getActionStats = () => {
    // console.log('called!')
    let params = {
      enterpriseId: this.props.eo_id,
    };
    this.setState({ loading: true });
    axios
      .get(url.getAvgTaskCompletion, {
        params: params,
      })
      .then((result) => {
        this.setState({ loading: false });
        // console.log('data---',  result)
        let data = result.data.data,
          avg;

        if (data && data[0] && data[0].avg) {
          avg = data[0].avg;
        } else {
        }

        this.setState({ avg });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  render() {
    let { avg, isAllEOPage, loading } = this.state;
    // console.log(this.props)
    if (avg) {
      return (
        <span>
          <div className="enterpriseObjStatInt">
            {avg.toFixed(0)}
            <span>%</span>
          </div>
        </span>
      );
    } else if (loading) {
      return (
        <div>
          Loading...
        </div>
      );
    } else if (!avg) {
      return (
        <span>
          <div className={isAllEOPage ? "" : "actionStatsNA"}> No tasks </div>
          <p className="actionStatsNAsubtitle"> in progress </p>
        </span>
      );
    } else {
      return (
        <div>
          Loading...
        </div>
      );
    }
  }
}

export default AvgCompletion;
